import "firebase/firestore";
import "firebase/auth";
import axios from "axios";
import firebase from "firebase/app";
import moment from "moment";

import { REMOVE_NOTIFICATION, SET_IS_FIREBASE_AUTHENTICATED, SET_NOTIFICATION, SET_NOTIFICATIONS, SET_PUBLISH_SUCCEEDED } from "./types";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";
import appConfig from "../config/appConfig";

const firestore = {
  get getCollection() {
    return firebase.firestore().collection(appConfig("REACT_APP_FIREBASE_NOTIFICATION_COLLECTION_NAME"));
  }
};

const handleRealTimeNotifications = callback => {
  callback();
  setInterval(callback, 60000);
};

export const initializeFirebaseApp = createAsyncAction(
  resolve => (email, callback) =>
    resolve(async dispatch => {
      firebase.initializeApp({
        apiKey: appConfig("REACT_APP_FIREBASE_API_KEY"),
        authDomain: appConfig("REACT_APP_FIREBASE_AUTH_DOMAIN"),
        projectId: appConfig("REACT_APP_FIREBASE_PROJECT_ID")
      });

      const response = await axios.get(`${getApiUrl()}/firebasetoken`, { params: { email } });
      await firebase.auth().signInWithCustomToken(response.data);
      handleRealTimeNotifications(callback);
      dispatch({ type: SET_IS_FIREBASE_AUTHENTICATED, payload: true });
    }),
  dispatch => dispatch({ type: SET_IS_FIREBASE_AUTHENTICATED, payload: false })
);

export const getNotifications = createAsyncAction(
  resolve => () =>
    resolve(async dispatch => {
      const response = await axios.get(`${getApiUrl()}/notifications`);
      dispatch({ type: SET_NOTIFICATIONS, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_NOTIFICATIONS, payload: [] })
);

export const publishNotification = createAsyncAction(
  resolve => ({ expiresIn, message, messageType, sender }) =>
    resolve(async dispatch => {
      const created = moment();
      const expired = moment().add(expiresIn, "days");
      const payload = { message, messageType, sender, recipient: null, created: created.toISOString(), expired: expired.toISOString() };
      const notificationRef = await firestore.getCollection.add(payload);
      const response = await axios.get(`${getApiUrl()}/notifications/${notificationRef.id}`);
      dispatch({ type: SET_NOTIFICATION, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_NOTIFICATIONS, payload: [] })
);

export const updateNotification = createAsyncAction(
  resolve => ({ id, message, messageType, sender, expired }) =>
    resolve(async dispatch => {
      await firestore.getCollection.doc(id).delete();
      const payload = { message, messageType, sender, recipient: null, created: moment().toISOString(), expired };
      const notificationRef = await firestore.getCollection.add(payload);
      const response = await axios.get(`${getApiUrl()}/notifications/${notificationRef.id}`);
      dispatch({ type: REMOVE_NOTIFICATION, payload: id });
      dispatch({ type: SET_NOTIFICATION, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_NOTIFICATIONS, payload: [] })
);

export const deleteNotification = createAsyncAction(
  resolve => id =>
    resolve(async dispatch => {
      await firestore.getCollection.doc(id).delete();
      dispatch({ type: REMOVE_NOTIFICATION, payload: id });
    }),
  dispatch => dispatch({ type: SET_NOTIFICATIONS, payload: [] })
);

export const setPublishSucceeded = payload => ({ type: SET_PUBLISH_SUCCEEDED, payload });



// WEBPACK FOOTER //
// ./src/actions/notificationActions.js